<template>
  <a href="javascript:;" class="dropdown-item"
    ><span><i class="bx bx-smile"></i></span>React</a
  >
  <a
    href="javascript:;"
    class="dropdown-item"
    data-bs-toggle="modal"
    data-bs-target="#forward-message"
    ><span><i class="bx bx-reply"></i></span>Forward</a
  >
  <a href="javascript:;" class="dropdown-item click-star-one"
    ><span><i class="bx bx-star"></i></span
    ><span class="star-msg-one">Star Message</span></a
  >
  <a href="javascript:;" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#edit-message"
    ><span><i class="bx bx-edit-alt"></i></span>Edit</a
  >
  <a
    href="javascript:;"
    class="dropdown-item"
    data-bs-toggle="modal"
    data-bs-target="#delete-message"
    ><span><i class="bx bx-trash"></i></span>Delete</a
  >
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
